if (!customElements.get('main-hero-section')) {
  class MainHeroSection extends HTMLElement {
    connectedCallback() {
      this.slides = this.querySelectorAll('.section-main-hero__slide');
      this.dots = this.querySelectorAll('.section-main-hero__dot');
      this.currentIndex = 0;
      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.autoplayTimer = null;

      /* Swipe / drag tracking */
      this.pointerStartX = 0;
      this.pointerStartY = 0;
      this.pointerEndX = 0;
      this.isDragging = false;
      this.swipeThreshold = 50;

      if (this.slides.length <= 1) return;

      /* ---- Dot navigation ---- */
      this.dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          this.goToSlide(index);
        }.bind(this));
      }.bind(this));

      /* ---- Touch events (mobile swipe) ---- */
      this.addEventListener('touchstart', function (e) {
        this.onPointerStart(e.touches[0].clientX, e.touches[0].clientY);
      }.bind(this), { passive: true });

      this.addEventListener('touchmove', function (e) {
        this.onPointerMove(e.touches[0].clientX);
      }.bind(this), { passive: true });

      this.addEventListener('touchend', function () {
        this.onPointerEnd();
      }.bind(this));

      /* ---- Mouse drag events (desktop) ---- */
      this.addEventListener('mousedown', function (e) {
        this.isDragging = true;
        this.onPointerStart(e.clientX, e.clientY);
      }.bind(this));

      this.addEventListener('mousemove', function (e) {
        if (!this.isDragging) return;
        e.preventDefault();
        this.onPointerMove(e.clientX);
      }.bind(this));

      this.addEventListener('mouseup', function () {
        if (!this.isDragging) return;
        this.isDragging = false;
        this.onPointerEnd();
      }.bind(this));

      this.addEventListener('mouseleave', function () {
        if (this.isDragging) {
          this.isDragging = false;
          this.onPointerEnd();
        }
      }.bind(this));

      /* ---- Auto-rotate ---- */
      if (this.autoplay) {
        this.startAutoplay();

        this.addEventListener('mouseenter', function () {
          this.stopAutoplay();
        }.bind(this));

        this.addEventListener('mouseleave', function () {
          if (!this.isDragging) this.startAutoplay();
        }.bind(this));

        this.addEventListener('focusin', function () {
          this.stopAutoplay();
        }.bind(this));

        this.addEventListener('focusout', function () {
          this.startAutoplay();
        }.bind(this));
      }
    }

    /* ---- Pointer helpers ---- */

    onPointerStart(x, y) {
      this.pointerStartX = x;
      this.pointerStartY = y;
      this.pointerEndX = x;
      this.stopAutoplay();
    }

    onPointerMove(x) {
      this.pointerEndX = x;
    }

    onPointerEnd() {
      var deltaX = this.pointerEndX - this.pointerStartX;

      if (Math.abs(deltaX) > this.swipeThreshold) {
        if (deltaX < 0) {
          this.nextSlide();
        } else {
          this.prevSlide();
        }
      }

      if (this.autoplay) {
        this.startAutoplay();
      }
    }

    /* ---- Slide navigation ---- */

    goToSlide(index) {
      if (index === this.currentIndex) return;

      this.slides[this.currentIndex].classList.remove('section-main-hero__slide--active');
      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.remove('section-main-hero__dot--active');
      }

      this.currentIndex = index;

      this.slides[this.currentIndex].classList.add('section-main-hero__slide--active');
      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.add('section-main-hero__dot--active');
      }
    }

    nextSlide() {
      this.goToSlide((this.currentIndex + 1) % this.slides.length);
    }

    prevSlide() {
      this.goToSlide((this.currentIndex - 1 + this.slides.length) % this.slides.length);
    }

    /* ---- Autoplay ---- */

    startAutoplay() {
      this.stopAutoplay();
      this.autoplayTimer = setInterval(function () {
        this.nextSlide();
      }.bind(this), this.speed);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }
  }

  customElements.define('main-hero-section', MainHeroSection);
}
